import { useSelector } from "react-redux"
import { vnzImagesSelectors } from "~/redux/state/VNZImages"
import { RootState } from "~/redux/store"

export const useVNZImages = () => {
  const allVnzImages = useSelector((state: RootState) =>
    vnzImagesSelectors.selectAll(state)
  )
  const isLoading = useSelector((state: RootState) => state.VNZImages.isLoading)
  const hasError = useSelector((state: RootState) => state.VNZImages.hasError)
  const error = useSelector((state: RootState) => state.VNZImages.error)

  const hasLoadedImages = !isLoading && !hasError && allVnzImages.length > 0
  const hasNoImages = !isLoading && !hasError && allVnzImages.length === 0

  return {
    allVnzImages,
    isLoading,
    hasError,
    error,
    hasLoadedImages,
    hasNoImages,
  }
}
